import { AnvilSelectOptionsProps, BodyText, Stack } from '@servicetitan/design-system';
import { FC } from 'react';
import { SelectOption } from '../../utils/form';

export const addressOptionFilter: (
    search: string
) => (opt: SelectOption<number, string>) => boolean = search => opt =>
    opt.text.toLowerCase().includes(search) || !!opt.data?.toLowerCase().includes(search);

export const addressOptionFilterNew: (
    search: string
) => (option: AnvilSelectOptionsProps) => boolean = search => option =>
    !!option.text?.toLowerCase().includes(search) || !!option.data?.toLowerCase().includes(search);

export const AddressOptionComponent: FC<{ opt: SelectOption<number, string> }> = ({ opt }) => (
    <Stack direction="column" className="m-l-half p-t-half">
        <BodyText size="small" bold>
            {opt.text}
        </BodyText>
        <BodyText size="small">{opt.data}</BodyText>
    </Stack>
);

export const AddressOptionComponentNew: FC<{ option: AnvilSelectOptionsProps }> = ({ option }) => {
    return (
        <Stack direction="column" className="m-l-half p-t-half">
            <BodyText size="small" bold>
                {option.data}
            </BodyText>
            <BodyText size="small">{option.text}</BodyText>
        </Stack>
    );
};
